export enum PageDonationDonorsActionTypes {
  // Fetching all donors.
  PAGE_DONATIONS_DONORS_FETCH_LOADING = 'PAGE_DONATIONS_DONORS_FETCH_LOADING',
  PAGE_DONATIONS_DONORS_FETCH_ERROR = 'PAGE_DONATIONS_DONORS_FETCH_ERROR',
  PAGE_DONATIONS_DONORS_FETCH_SUCCESS = 'PAGE_DONATIONS_DONORS_FETCH_SUCCESS',
}
